export default {
  newDesign: true,
  parameters: {
    landing_id: "BrQuScoGs",
    segment: 42,
    success_page: "success_long",
  },
  title:
    "Responda a estas perguntas e ganhe uma aula experimental para seu filho/a! | Kodland",
  downtimeUrl: "https://www.kodland.org/pt",
  startPage: {
    title:
      "Responda a estas perguntas e ganhe uma aula experimental para seu filho/a!",
    subtitle:
      "📕 Aulas para crianças de 8 a 17 anos<br>💻 Só precisa de um computador e acesso à internet<br>💙 Já escolhido por mais de 200.000 pais",
    image: {
      url: "/welcome/brazil_scoring_google_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/brazil_scoring_google_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "Começar →",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Obrigado por confiar em nossa plataforma educacional!",
    subtitle:
      "Infelizmente, tablets ou telefones não são adequados para assistir às nossas aulas. Ficaremos felizes em vê-lo em nossas aulas na próxima vez!",
  },
  customStopPages: {
    internet: {
      title: "Obrigado por confiar na nossa plataforma educacional!",
      subtitle:
        "Infelizmente, nossas aulas precisam de uma conexão de internet estável e rápida para funcionar corretamente. Por favor, verifique sua conexão antes de tentar novamente. Esperamos ver você em nossas aulas em breve!",
      image: "/welcome/quizV2/no-computer.png",
    },
    child: {
      title: "Obrigado por confiar na nossa plataforma educacional!",
      subtitle:
        "Infelizmente, apenas um pai, mãe ou responsável pode fazer o cadastro para as aulas. Por favor, envie o link do nosso site para seus pais, se quiser continuar. Estamos ansiosos para ver você em nossas aulas!",
      image: "/welcome/quizV2/child-parent.png",
    },
  },
  quizRotateBySteps: {
    1: {
      question: "Você é pai, mãe ou filho/a?",
      answers: [
        "Pai",
        "Mãe",
        {
          answer: "Filho(a)",
          redirectToBackupForm: true,
        },
      ],
    },
    2: {
      title: "Quantos anos tem seu filho/a?",
      type: "age",
      button: "",
    },
    3: {
      question: "Em que tipo de escola seu filho estuda?",
      answers: [
        "Pública 🍎",
        "Privada 🏫",
        "Internacional / Bilíngue 🌎",
        "Homeschooling 🏡",
      ],
    },
    4: {
      question: "Quais são as matérias preferidas do seu filho na escola?",
      answers: [
        "Ciências ou matemática 🧪",
        "Arte, música ou atividades criativas 🎨",
        "Educação física ou esportes 🥇",
        "Outro 😊",
      ],
    },
    5: {
      question: "Qual é o nível de escolaridade mais alto na sua família?",
      answers: [
        "Mestrado / superior 🎓",
        "Licenciatura 🎓",
        "Ensino médio 🏫",
        "Ensino técnico / pré-vestibular 📚",
      ],
    },
    6: {
      question:
        "Quantos dispositivos (computador, celular ou tablet) seu filho pode usar em casa?",
      answers: ["0 – Não possui", "1 dispositivo", "2 ou mais dispositivos"],
    },
    7: {
      question: "Que tipo de acesso à internet vocês têm em casa?",
      answers: [
        "Internet de alta velocidade (fibra)",
        {
          answer: "Internet básica (ADSL)",
          redirectToBackupForm: true,
        },
        {
          answer: "Apenas dados móveis",
          redirectToBackupForm: true,
        },
        {
          answer: "Não temos acesso confiável",
          redirectToBackupForm: true,
        },
      ],
    },
    8: {
      question:
        "Quando você gostaria que seu filho começasse as aulas de programação?",
      answers: [
        "Esta semana",
        {
          answer: "Em 2–4 semanas",
          redirectToBackupForm: true,
        },
        {
          answer: "Em 1–3 meses",
          redirectToBackupForm: true,
        },
        {
          answer: "Apenas explorando",
          redirectToBackupForm: true,
        },
      ],
    },
    9: {
      question:
        "Você tem um computador de mesa ou notebook que seu filho possa usar para estudar?",
      answers: [
        "💻 Sim",
        {
          answer: "😞 Não",
          stopAnswer: true,
        },
      ],
    },
    10: {
      dynamicTypeInfo: [
        {
          condition: [
            {
              step: 3,
              answer: "Privada 🏫",
            },
            {
              step: 4,
              answer: "Ciências ou matemática 🧪",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 3,
              answer: "Internacional / Bilíngue 🌎",
            },
            {
              step: 4,
              answer: "Ciências ou matemática 🧪",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 3,
              answer: "Privada 🏫",
            },
            {
              step: 5,
              answer: "Mestrado / superior 🎓",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 3,
              answer: "Privada 🏫",
            },
            {
              step: 5,
              answer: "Licenciatura 🎓",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 3,
              answer: "Internacional / Bilíngue 🌎",
            },
            {
              step: 5,
              answer: "Mestrado / superior 🎓",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 3,
              answer: "Internacional / Bilíngue 🌎",
            },
            {
              step: 5,
              answer: "Licenciatura 🎓",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 3,
              answer: "Privada 🏫",
            },
            {
              step: 6,
              answer: "2 ou mais dispositivos",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 3,
              answer: "Internacional / Bilíngue 🌎",
            },
            {
              step: 6,
              answer: "2 ou mais dispositivos",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 3,
              answer: "Privada 🏫",
            },
            {
              step: 8,
              answer: "Esta semana",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 3,
              answer: "Internacional / Bilíngue 🌎",
            },
            {
              step: 8,
              answer: "Esta semana",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 4,
              answer: "Ciências ou matemática 🧪",
            },
            {
              step: 5,
              answer: "Mestrado / superior 🎓",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 4,
              answer: "Ciências ou matemática 🧪",
            },
            {
              step: 5,
              answer: "Licenciatura 🎓",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 4,
              answer: "Ciências ou matemática 🧪",
            },
            {
              step: 6,
              answer: "2 ou mais dispositivos",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 4,
              answer: "Ciências ou matemática 🧪",
            },
            {
              step: 8,
              answer: "Esta semana",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 5,
              answer: "Mestrado / superior 🎓",
            },
            {
              step: 6,
              answer: "2 ou mais dispositivos",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 5,
              answer: "Licenciatura 🎓",
            },
            {
              step: 6,
              answer: "2 ou mais dispositivos",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 5,
              answer: "Mestrado / superior 🎓",
            },
            {
              step: 8,
              answer: "Esta semana",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 5,
              answer: "Licenciatura 🎓",
            },
            {
              step: 8,
              answer: "Esta semana",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },
        {
          condition: [
            {
              step: 6,
              answer: "2 ou mais dispositivos",
            },
            {
              step: 8,
              answer: "Esta semana",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
              "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
          },
        },

        {
          default: true,
          data: {
            typeInfo: "noButton",
            title: "Obrigado por confiar na nossa plataforma educacional!",
            subtitle:
              "Infelizmente, neste momento não podemos concluir seu cadastro para as aulas. Se tiver alguma dúvida, você pode nos escrever para o e-mail: social@kodland.org.<br>Esperamos poder te ajudar em breve!",
          },
        },
      ],
    },
    11: {
      title: "Inscreva-se em uma aula experimental",
      type: "one-page-contacts",
      subtitle:
        "Veja como seu filho pode começar a programar com a nossa ajuda.",
      button: "Quase lá! 🔥",
    },
    12: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    13: {
      title: "Obrigado 🎉 Faltam apenas alguns passos para concluir o cadastro",
      typeInfo: "pc-laptop",
      subtitle:
        "Por favor, observe que você precisará de um PC ou laptop funcional para a aula e que deve acompanhar seu filho durante toda a aula. Lembre-se de que a aula é individual e personalizada.",
      button: "O que mais?",
    },
    14: {
      title: "Verifique seu e-mail e WhatsApp antes da aula experimental 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Enviaremos um lembrete 24 horas antes da aula e 2 horas antes da aula pediremos para você confirmar sua presença. É muito importante que mantenhamos contato para que a aula não seja cancelada.",
      button: "O que mais?",
    },
    15: {
      title: "A aula vai acontecer na nossa plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Você vai receber um link e um código único pelo WhatsApp e e-mail. Basta clicar no link, ele vai te levar direto para a aula. Sem aplicativos extras, sem downloads.",
      button: "Entendi ✅",
    },
  },
};
